export default {"src":"/_next/static/media/driedherb.3c39a8a8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};